import { render, staticRenderFns } from "./Quizlet-alternatief.vue?vue&type=template&id=2fb998f8&scoped=true&"
import script from "./Quizlet-alternatief.vue?vue&type=script&lang=js&"
export * from "./Quizlet-alternatief.vue?vue&type=script&lang=js&"
import style0 from "./Quizlet-alternatief.vue?vue&type=style&index=0&id=2fb998f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb998f8",
  null
  
)

export default component.exports